export enum RouteParamMapEnum {
  OrderReference = 'orderReference',
  Culture = 'culture',
  OrderId = 'orderId',
  PNR = 'pnr',
  Id = 'id',
  FlightId = 'flightId',
}
export type RouteParamMapEnumType = keyof typeof RouteParamMapEnum;
